<!--
 - Author : 003.
 - Date   : 2019/6/3.
 - File   : ycArea.异常信息
 -->

<template>
  <div class="yc-area-cont">
    <div class="yc-area-wrap">
      <span class="border-h"></span>
      <div class="area-flex" v-for="(item, name, index) in list" :key="index">
        <div class="area-popup" v-if="item.showTag&&item.infoList.length">
          <span class="ico-tri"></span>
          <!--异常处置的组件:异常信息详情,处置异常，异常处置详情弹窗-->
          <excepHandle :class="['area-detail', 'area-detail' + index]"
              v-if="showRegion"
              :isScroll="true"
              :showChuRegion="showChuRegion"
              :current="current"
              :yCCLDetail="yCCLDetail"
              :disabled="disabled1"
              @cancelFn="cancelFn"
              @chuZhiFn="chuZhiFn1"
              :reset="reset"
              @closeEC="cancelFn">
          </excepHandle>
          <!--分区异常信息列表弹窗-->
          <Popover title="异常信息" width="420px" :class="['area-list', 'area-list'+index]"
              @closeEvent="item.showTag = false">
            <ul>
              <li v-for="(sItem, j) in item.infoList" :key="j" @click="seeOrEdit(sItem, '0')">
                <span class="info-date">{{sItem.occurrenceTime|timeFilter}}</span>
                <span class="info-txt"
                    :style="{paddingRight:(sItem.exceptionType!=='12' || sItem.exceptionType!=='13')?'0px':'70px'}">
                  {{sItem.deviceName}}{{sItem.content}}</span>
                <span
                    :class="[sItem.status==='02'?'area-btn0':'area-btn1']"
                    v-if="sItem.exceptionType!=='12' && sItem.exceptionType!=='13'">
                  {{sItem.status==='02'?'处置详情':'去处置'}}
                </span>
              </li>
            </ul>
            <el-pagination
                background
                hide-on-single-page
                layout="pager"
                :current-page="page"
                :page-size="pageSize"
                @current-change="pageChange"
                :total="total">
            </el-pagination>
          </Popover>
        </div>
        <div :class="['btn', item.exceptionCount===0? 'btn_0': (item.exceptionCount>2? 'btn_3': 'btn_1')]"
            @click="showList(item)" :title="item.exceptionCount">
          {{item.exceptionCount|shuLiangFilter}}
        </div>
        <span class="border_s"></span>
        <div class="show cus-pointer" @click="showList(item)">
          <h3>{{item.name}}</h3>
          <span v-if="item.exceptionCount>0"
              :class="[item.exceptionCount>2? 'yichang_3': 'yichang_1']">共有{{item.exceptionCount}}条异常信息!</span>
          <span v-if="item.exceptionCount===0">没有异常信息!</span>
        </div>
      </div>
    </div>
    <!--历史异常信息-->
    <div class="yc-his-list"><i class="iconfont icon-lishi" @click="showYcHisList"></i>
      <span @click="showYcHisList">历史异常信息 >></span></div>
    <datePopover
        class="yc-his"
        title="异常历史记录"
        width="800px"
        v-if="showYcHis"
        :aqiMsg="currentPos"
        @closeEvent="closeHis">
      <div class="pre-view">
        <el-form :inline="true" :model="formInline">
          <el-form-item label="异常类型">
            <el-select v-model="formInline.anomalousType" clearable placeholder="选择异常类型">
              <el-option label="全部" value="">
              </el-option>
              <el-option :label="item.detailName" :value="item.detailCode"
                  v-for="(item, re) in exceptionTypeList"
                  :key="re">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="选择区域">
            <el-select v-model="formInline.regionId" clearable placeholder="选择区域">
              <el-option label="全部" value="">
              </el-option>
              <el-option :label="item.regionName" :value="item.regionId"
                  v-for="(item, re) in regionIdList"
                  :key="re">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="选择时间">
            <el-col :span="11">
              <el-date-picker type="date" placeholder="选择开始日期" v-model="formInline.beginTime"
                  value-format="yyyy-MM-dd"
                  :picker-options="pickerOptionsStart"
                  style="width: 100%;">
              </el-date-picker>
            </el-col>
            <el-col class="line" :span="2">至</el-col>
            <el-col :span="11">
              <el-date-picker type="date" placeholder="选择结束日期" v-model="formInline.endTime"
                  value-format="yyyy-MM-dd"
                  :picker-options="pickerOptionsEnd"
                  style="width: 100%;">
              </el-date-picker>
            </el-col>
          </el-form-item>
          <el-form-item label="异常关键字">
            <el-input v-model.trim="formInline.keyword" clearable></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="searchYcHisList">查询</el-button>
            <el-button type="primary" @click="resetYcHis">重置</el-button>
            <el-button type="primary" @click="exportYc">导出搜索结果</el-button>
          </el-form-item>
        </el-form>
      </div>
      <el-table
          class="test1"
          :data="tableData"
          style="width: 100%">
        <el-table-column
            prop="occurrenceTime"
            width="150"
            label="异常时间">
          <template slot-scope="scope">
            <span class="food-name" @click="seeOrEdit(scope.row, '1')">{{scope.row.occurrenceTime|DateFilter}}</span>
          </template>
        </el-table-column>
        <el-table-column
            prop="content"
            label="异常信息">
          <template slot-scope="scope">
            <span class="result" @click="seeOrEdit(scope.row, '1')">{{scope.row.deviceName}}{{scope.row.content}}</span>
          </template>
        </el-table-column>
        <el-table-column
            prop="status"
            align="center"
            width="80"
            label="状态">
          <template slot-scope="scope"
              v-if="scope.row.exceptionType!=='12' && scope.row.exceptionType!=='13'">
            <span
                :class="[scope.row.status==='02'?'area-btn2':'area-btn3']"
                @click="seeOrEdit(scope.row, '1')">
              {{scope.row.status==='02'?'处置详情':'去处置'}}
            </span>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
          background
          :page-size="parseInt(pageSize1)"
          :current-page="currentPage1"
          @current-change="handleCurrentChange"
          layout="prev, pager, next"
          :total="total1">
      </el-pagination>
      <!--异常处置的组件:异常信息详情,处置异常，异常处置详情弹窗-->
      <excepHandle class="his-handle"
          v-if="showRegionHis"
          :showChuRegion="showChuRegionHis"
          :reset="reset"
          :current="current"
          :yCCLDetail="yCCLDetail"
          :disabled="disabled"
          @cancelFn="cancelFn('his')"
          @chuZhiFn="chuZhiFn"
          @closeEC="cancelFn('his')">
      </excepHandle>
    </datePopover>
  </div>
</template>

<script>
  export default {
    name: 'ycArea',
    data () {
      return {
        deptId: this.$route.query.deptId,
        imgUrl: this.$store.getters.fileApi,
        disabled: false,
        disabled1: false,
        page: 1,
        pageSize: 5,
        total: 10,
        currentPage1: 1,
        pageSize1: 10,
        total1: 10,
        list: {
          't1':
            {
              name: '加载中',
              showTag: false,
              exceptionCount: 0,
              infoList: []
            },
          't2': {
            name: '加载中',
            exceptionCount: 0,
            showTag: false,
            infoList: []
          },
          't3': {
            name: '加载中',
            exceptionCount: 0,
            showTag: false,
            infoList: []
          },
          't4': {
            name: '加载中',
            exceptionCount: 0,
            showTag: false,
            infoList: []
          },
          't5': {
            name: '加载中',
            exceptionCount: 0,
            showTag: false,
            infoList: []
          },
          't6': {
            name: '加载中',
            exceptionCount: 0,
            showTag: false,
            infoList: []
          }
        },
        current: {},
        currentRegionId: '',
        showRegion: false, // 当天异常信息弹窗
        showChuRegion: false, // 当天处置异常信息弹窗
        showRegionHis: false, // 历史异常信息弹窗
        showChuRegionHis: false, // 历史处置异常信息弹窗
        showYcHis: false,
        currentPos: {},
        tableData: [],
        formInline: {
          regionId: '',
          beginTime: '',
          endTime: '',
          anomalousType: '',
          keyword: ''
        },
        exceptionTypeList: [],//异常类型
        pickerOptionsStart: {
          disabledDate: time => {
            if (this.formInline.endTime) {
              return time.getTime() > new Date(this.formInline.endTime).getTime()
            } else {
              return time.getTime() > Date.now()
            }
          }
        },
        pickerOptionsEnd: {
          disabledDate: time => {
            if (this.formInline.beginTime) {
              return (time.getTime() < new Date(this.formInline.beginTime).getTime() - 86400000) || (time.getTime() > Date.now())
            } else {
              return time.getTime() > Date.now()
            }
          }
        },
        regionIdList: [],
        desc: '', // 填写处置详情
        yCCLDetail: {}, // 异常处理详情
        uploadList: [],
        reset: false,
        fileUrl: this.$store.getters.fileApi
      }
    },
    props: {
      state: {},
      floorId: '',
      contractorId: ''
    },
    mounted () {
      this.getQuYuList()
      window.getYiChangMsg = data => {
        this.getYiChangMsg(this.deptId, this.page, this.pageSize, data.content.regionId)
      }
      window.getYiChangMsgTotal = () => {
        this.getQuYuList()
      }
    },
    methods: {
      /**
       * @Description:从字典中获取异常类型
       * @author wanghongling
       * @createDate 2020/12/16
      */
      getDictionaryDetailList() {
        this.$request.dictionaryDetailList({dictionaryCode: 'ANOMALOUS_TYPE'}).then(res => {
          if(!this.$utils.isEmptyObject(res)) {
            this.exceptionTypeList = res
          }
          console.log('从字典中获取异常类型', res)
        }).catch(e => {
          console.error(e)
        })
      },
      /**
       * 关闭历史记录列表
       * @author wanghongling
       * @createTime 2019/07/26
       */
      closeHis () {
        this.showYcHis = false
        this.showRegionHis = false
      },
      /**
       * 切换分页
       * @author wanghongling
       * @param currentPage 当前页
       * @createTime 2019/07/26
       */
      pageChange (currentPage) {
        this.showRegion = false
        this.page = currentPage
        this.getYiChangMsg(this.deptId, currentPage, this.pageSize, this.currentRegionId)
      },
      /**
       * 显示异常列表
       * @author zhzhy
       * @param item
       * @createTime 2019/07/26
       */
      showList (item) {
        this.showYcHis = false
        Object.values(this.list).forEach(e => {
          e.showTag = false
        })
        this.page = 1
        item.showTag = true
        this.showRegion = false
        this.currentRegionId = item.regionId
        this.total = item.exceptionCount
        this.getYiChangMsg(this.deptId, this.page, this.pageSize, this.currentRegionId)
        this.current = {}
      },
      /**
       * @Description:显示仓库区
       * @author wanghongling
       * @param item
       * @createDate 2019/11/8
       */
      showCK (item) {
        console.log('item', item)
        if (item.name === '仓库区') {
          this.$emit('showCK', 0)
        } else {
          this.$emit('showCK')
        }
      },
      /**
       * 重置处置框填写的内容
       * @author wanghongling
       * @createTime 2019/07/26
       */
      onReset () {
        this.reset = !this.reset
      },
      /**
       * 查看异常详情或处置异常信息
       * @author wanghongling
       * @createTime 2019/07/23
       */
      seeOrEdit (sItem, type) {
        console.log('sItem查看异常详情或处置异常信息:', sItem)
        if (sItem.exceptionType === '12' || sItem.exceptionType === '13') {
          this.$superMessage('提示', '食品过期异常请至业务数据中心处理！')
        } else {
          this.current = {}
          this.regionExceptionInfo(sItem.exceptionId)
          let tmpShowRegion = false
          let tmpShowChuRegion = false
          // 处置异常信息
          this.onReset()
          tmpShowRegion = true
          tmpShowChuRegion = true
          this.current = sItem
          if (sItem.status === '02') this.getExceptionExplanationInfo(sItem.exceptionId)
          switch (type) {
            case '0':
              this.showRegion = tmpShowRegion
              this.showChuRegion = tmpShowChuRegion
              break
            case '1':
              // 历史异常处置
              this.showRegionHis = tmpShowRegion
              this.showChuRegionHis = tmpShowChuRegion
              break
          }
          if (this.showRegionHis) this.showRegionHis = !this.showRegion
        }
      },
      /**
       * 获取异常处理详情调用接口
       * @author wanghongling
       * @createTime 2019/07/23
       */
      getExceptionExplanationInfo (exceptionId) {
        this.$request.exceptionExplanationInfoGet({exceptionId}).then(res => {
          console.log('获取异常处理详情调用接口****', res)
          this.yCCLDetail = res
        }).catch(e => {
          console.error(e)
        })
      },
      /**
       * 组件异常处置调用接口
       * @author wanghongling
       * @createTime 2019/07/26
       */
      chuZhiFn1 (desc, uploadList) {
        let params = {
          exceptionId: this.current.exceptionId,
          explanation: desc,
          fileList: uploadList
        }
        console.log('params:', params)
        this.disabled1 = true
        this.$request.exceptionInfoUpdate(params).then(() => {
          this.$superMessage('提示', '处置成功')
          this.getYiChangMsg(this.deptId, this.page, this.pageSize, this.currentRegionId)
          this.showRegion = false
          this.disabled1 = false
        }).catch(e => {
          console.error(e)
          this.disabled1 = false
        })
      },
      /**
       * 组件异常处置调用接口
       * @author wanghongling
       * @createTime 2019/07/26
       */
      chuZhiFn (desc, uploadList) {
        let params = {
          exceptionId: this.current.exceptionId,
          explanation: desc,
          fileList: uploadList
        }
        this.disabled = true
        console.log('params:', params)
        this.$request.exceptionInfoUpdate(params).then(() => {
          this.$superMessage('提示', '处置成功')
          this.getYcHisList(this.deptId, this.currentPage1, this.pageSize1)
          this.showRegionHis = false
          this.disabled = false
        }).catch(e => {
          console.error(e)
          this.disabled = false
        })
      },
      /**
       * 组件的取消处置,关闭异常详情信息弹窗
       * @author wanghongling
       * @createTime 2019/07/26
       */
      cancelFn (type) {
        if (type) {
          this.showRegionHis = false
        } else {
          this.showRegion = false
        }
      },
      /**
       * 获取异常信息详情调用接口
       * @author: whl
       * @createDate: 2019/6/14
       */
      regionExceptionInfo (exceptionId) {
        this.$request.regionExceptionInfoGet({exceptionId}).then(res => {
          this.$set(this.current, 'deviceName', res.deviceName)
          this.$set(this.current, 'anchorName', res.anchorName)
          this.$set(this.current, 'regionName', res.regionName)
          this.$set(this.current, 'anomalousTypeName', res.anomalousTypeName)
          this.$set(this.current, 'deptName', res.deptName)
          this.$set(this.current, 'exceptionImageUrl', res.fileList[0] ? this.imgUrl + res.fileList[0] : '')
          this.$set(this.current, 'content', res.content)
          this.$request.fileExceptionPrtscreenListGet({targetId: exceptionId}).then(res => {
            this.$set(this.current, 'fileList', res)
          }).catch(e => {
            console.error(e)
          })
        }).catch(e => {
          console.error(e)
        })
      },
      /**
       * getYiChangMsg获取当天各区域的异常信息
       * @author: whl
       * @createDate: 2019/6/14
       * @param {String} page 页码
       * @param {String} pageSize 每页个数
       * @param {String} regionId 区域id
       * @param departmentId
       * @return {Object}
       */
      getYiChangMsg (departmentId, page, pageSize, regionId) {
        this.$request.exceptionTodayRegiondeptListGet({departmentId, page, pageSize, regionId}).then(resp => {
          if (!this.$utils.isEmptyObject(resp)) {
            this.list[regionId].infoList = resp.resultList
            this.list[regionId].exceptionCount = resp.totalCount
            console.log(resp, '获取当天各区域的异常信息')
          }
        }).catch(e => {
          console.error(e)
        })
      },
      /**
       * getQuYuList
       * @author: zhzhy
       * @createDate: 2019/6/14
       * @return {Object}
       */
      getQuYuList () {
        this.$request.regionNoconditionListGet().then(res => {
          this.list = {}
          this.regionIdList = res
          console.log(res, 'quYuListGetquYuListGet~~~')
          res.forEach(v => {
            this.$set(this.list, v.regionId, {
              name: v.regionName,
              regionId: v.regionId,
              showTag: false,
              exceptionCount: 0,
              infoList: []
            })
            this.getYiChangMsg(this.deptId, this.page, this.pageSize, v.regionId)
          })
        }).catch(e => {
          console.error(e)
        // this.$superMessage('提示', e)
        })
      },
      /**
       * 显示异常信息历史记录弹窗
       * @author wanghongling
       * @createTime 2019/07/24
       */
      showYcHisList () {
        Object.values(this.list).forEach(e => {
          e.showTag = false
        })
        this.formInline = {}
        this.currentPage1 = 1
        this.showRegion = false
        this.showRegionHis = false
        this.showYcHis = !this.showYcHis
        this.getDictionaryDetailList() // 获取异常类型
        this.getYcHisList(this.deptId, this.currentPage1, this.pageSize1)
      },
      /**
       * 条件查询异常信息
       * @author wanghongling
       * @createTime 2019/07/24
       */
      searchYcHisList () {
        this.showRegionHis = false
        this.currentPage1 = 1
        this.getYcHisList(this.deptId, this.currentPage1, this.pageSize1)
      },
      /**
       * @Description:重置异常列表查询
       * @author wanghongling
       * @createDate 2020/12/16
      */
      resetYcHis() {
        this.currentPage1 = 1
        this.formInline = {
          regionId: '',
          beginTime: '',
          endTime: '',
          anomalousType: '',
          keyword: ''
        }
        this.getYcHisList(this.deptId, this.currentPage1, this.pageSize1)
      },
      /**
       * @Description:导出异常
       * @author wanghongling
       * @createDate 2020/12/16
      */
      exportYc() {
        let params = {
          departmentId: this.deptId,
          page: this.currentPage1,
          pageSize: this.pageSize1
        }
        if(this.formInline.regionId) params.regionId = this.formInline.regionId
        if(this.formInline.beginTime) params.beginTime = this.formInline.beginTime
        if(this.formInline.endTime) params.endTime = this.formInline.endTime
        if(this.formInline.anomalousType) params.anomalousType = this.formInline.anomalousType
        if(this.formInline.keyword) params.keyword = this.formInline.keyword
        this.$request.exceptionHistoryListExcelGet(params).then(res => {
          if (!this.$utils.isEmptyObject(res)) {
            console.error(res)
            let objectUrl = this.fileUrl + res
            window.location.download = '食堂异常统计报表' // 自定义文件名
            window.location.href = objectUrl
            URL.revokeObjectURL(objectUrl) // 释放内存
          } else {
            this.$superMessage('提示', '当前视图没有数据可供导出')
          }
        }).catch(e => {
          console.error(e)
        })
      },
      /**
       * 获取异常信息历史记录接口对接
       * @author wanghongling
       * @createTime 2019/07/24
       */
      getYcHisList (departmentId, page, pageSize) {
        let params = {
          departmentId,
          page,
          pageSize
        }
        if(this.formInline.regionId) params.regionId = this.formInline.regionId
        if(this.formInline.beginTime) params.beginTime = this.formInline.beginTime
        if(this.formInline.endTime) params.endTime = this.formInline.endTime
        if(this.formInline.anomalousType) params.anomalousType = this.formInline.anomalousType
        if(this.formInline.keyword) params.keyword = this.formInline.keyword
        this.$request.exceptionHistoryListGet(params).then(res => {
          console.log('历史记录', res)
          if (!this.$utils.isEmptyObject(res)) {
            this.tableData = res.resultList
            this.total1 = res.totalCount
          }
        }).catch(e => {
          console.error(e)
        // this.$superMessage('提示', e)
        })
      },
      /**
       * 历史列表页码改变
       * @author wanghongling
       * @createDate 2019-07-23
       * @param {Object} e 页码
       */
      handleCurrentChange (e) {
        this.currentPage1 = e
        this.showRegionHis = false
        this.getYcHisList(this.deptId, this.currentPage1, this.pageSize1)
      }
    }
  }
</script>

<style lang="less" rel="stylesheet/less">
  @import '../../assets/less/color';

  .yc-area-cont {
    .yc-area-wrap {
      display: flex;
      width: 1345px;

      .border-h {
        display: block;
        position: absolute;
        left: 5%;
        top: 29px;
        width: 90%;
        height: 1px;
        z-index: 1;
        background: #02759b;
      }

      .area-flex {
        flex: 1;
        position: relative;

        .ico-tri {
          position: absolute;
          bottom: -12px;
          left: -13px;
          width: 26px;
          height: 13px;
          background: url("../../assets/images/shitang/btn_tri.png");
          z-index: 9;
        }

        .area-popup {
          position: absolute;
          bottom: 190px;
          z-index: 99;
          left: 50%;
          width: 100px;

          .area-detail0 {
            transform: translateX(-30%) !important;
          }

          .area-detail5 {
            transform: translateX(-75%) !important;
          }

          .area-detail {
            margin-bottom: 10px;
            transform: translateX(-50%);
          }

          .area-list {
            ul {
              li {
                position: relative;
                /*height: 30px;*/
                font-size: 14px;
                padding-bottom: 10px;

                .info-date {
                  position: absolute;
                  color: @darkBlue;
                  cursor: pointer;
                }

                .cursor-none {
                  cursor: default !important;
                }

                .info-txt {
                  max-width: 310px;
                  cursor: pointer;
                  padding-left: 100px;
                  padding-right: 70px;
                  color: @lightBlue;
                  display: -webkit-box;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  word-break: break-all;
                  -webkit-box-orient: vertical;
                  -webkit-line-clamp: 1;
                }
              }
            }
          }

          .area-list0 {
            margin-left: -120px
          }

          .area-list1, .area-list2, .area-list3, .area-list4 {
            transform: translateX(-50%);
          }

          .area-list5 {
            margin-left: -279px
          }
        }

        .btn {
          cursor: pointer;
          position: relative;
          width: 52px;
          height: 52px;
          margin: auto;
          background-repeat: no-repeat;
          background-position: 0;
          color: #fff;
          line-height: 52px;
          /*cursor: default;*/
          z-index: 2;
        }

        @keyframes btnScale {
          0% {
            transform: scale(0.8);
          }
          50% {
            transform: scale(1);
          }
          100% {
            transform: scale(1.2);
          }
        }

        .btn:hover {
          cursor: pointer;
          animation: btnScale 0.8s linear infinite alternate;
        }

        .btn_0 {
          background-image: url("../../assets/images/shitang/btn_green.png");
        }

        .btn_1, .btn_2 {
          background-image: url("../../assets/images/shitang/btn_yellow.png");
        }

        .btn_3 {
          background-image: url("../../assets/images/shitang/btn_red.png");
        }

        .border_s {
          display: block;
          position: relative;
          margin: -5px auto;
          width: 1px;
          height: 30px;
          z-index: 1;
          background: #02759b;
        }

        .cus-pointer {
          cursor: pointer;
        }

        .show {
          width: 210px;
          height: 101px;
          margin: auto;
          background: url("../../assets/images/shitang/area_btn.png");

          h3 {
            line-height: 50px;
            color: #fff;
          }

          span {
            color: @green;
          }

          .yichang_1, .yichang_2 {
            color: @yellow;
          }

          .yichang_3 {
            color: #ff9f3c;
          }
        }
      }
    }

    .yc-his-list {
      color: #0aaade;
      margin-top: -10px;
      padding-right: 30px;
      text-align: right;

      i {
        font-size: 24px;
        vertical-align: sub;
        margin-right: 10px;
        cursor: pointer;
      }

      span {
        cursor: pointer;
      }
    }

    .yc-his {
      position: absolute;
      right: 0;
      bottom: 40px;
      z-index: 99;
    }

    .food-name {
      color: #00ffff;
    }

    .result {
      color: #00b7ee;
    }

    .el-table thead {
      color: #a3a9ac;
    }

    .el-table tr {
      background-color: #01212d00;
    }

    .el-table--enable-row-hover .el-table__body tr:hover > td {
      background-color: #265161;
    }

    .el-table th {
      padding: 8px 0;
    }

    .el-table td {
      padding: 6px 0;
    }

    .el-table td, .el-table th.is-leaf {
      border-bottom: none;
    }

    .el-table--border:after, .el-table--group:after, .el-table:before {
      content: "";
      position: absolute;
      background-color: rgba(0, 0, 0, 0);
      z-index: 1;
    }

    .el-table--fit {
      background: none !important;
    }

    .has-gutter tr th {
      background-color: #002f40;
    }

    .area-btn0 {
      position: absolute;
      right: 10px;
      top: 1px;
      font-size: 12px;
      color: @green;
      cursor: pointer;
    }

    .area-btn1 {
      position: absolute;
      right: 10px;
      top: 1px;
      display: inline-block;
      width: 50px;
      height: 20px;
      line-height: 20px;
      text-align: center;
      font-size: 12px;
      border-radius: 4px;
      color: #ff9000;
      background: #034463;
      cursor: pointer;
    }

    .area-btn2 {
      font-size: 12px;
      color: @green;
      cursor: pointer;
    }

    .area-btn3 {
      display: inline-block;
      width: 50px;
      height: 20px;
      line-height: 20px;
      text-align: center;
      font-size: 12px;
      border-radius: 4px;
      color: #ff9000;
      background: #034463;
      cursor: pointer;
    }

    .el-input__inner, .el-textarea__inner {
      background-color: #022643 !important;
      border: 1px solid #0a5c9c !important;
    }

    .el-form-item__label {
      color: #fff !important;
    }

    .el-input__inner, .el-textarea__inner {
      color: #00ffff !important;
    }

    .el-pagination.is-background .btn-next, .el-pagination.is-background .btn-prev, .el-pagination.is-background .el-pager li {
      color: rgba(255, 255, 255, 1);
      background: #216784;
    }

    .el-pagination {
      text-align: center;
    }

    .el-upload--picture-card {
      background-color: #022643 !important;
      border: 2px dashed #044c7f !important;
      width: 115px;
      height: 115px;
      line-height: 113px;
    }

    .el-upload-list--picture-card .el-upload-list__item {
      width: 115px;
      height: 115px;
    }

    .el-upload--picture-card i {
      color: #0475b7;
      font-weight: bolder;
    }

    .footer-btn {
      text-align: center;

      .el-button {
        padding: 10px 40px !important;
        background-color: #35556d;
        border-color: #35556d;
        color: #fff;
      }

      .el-button--primary {
        font-size: 16px !important;
        background-color: #009cff;
        border-color: #009cff;
      }

      .el-button--primary:hover {
        background-color: #e68d00 !important;
        border-color: #e68d00 !important;
      }

      .el-button:hover {
        background-color: #045591;
        border-color: #045591;
      }
    }

    .his-handle {
      position: absolute;
      right: 810px;
      bottom: 0;
    }

    .cursor {
      cursor: pointer;
    }

    .line {
      text-align: center;
      color: #fff;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/shitang/ycArea.vue